import React, {useEffect, useRef} from 'react';
import {useField} from '@unform/core';
import InputMask from 'react-input-mask';

const ReactInputCpfCnpj = (props) => {
    const {
        name,
        type,
        label,
        disabled
    } = props;
    const inputRef = useRef(null);
    const {fieldName, defaultValue, registerField, error} = useField(name);

    useEffect(() => {
        registerField({
            name: fieldName,
            ref: inputRef.current,
            path: 'value',
        });
    }, [registerField, fieldName]);


    return (
        <>
            {label && <label htmlFor={fieldName}>{label}</label>}

            <InputMask
                ref={inputRef}
                name={name}
                disabled={disabled}
                className={'form-control'}
                mask={type === 'cpf' ? '999.999.999-99' : '99.999.999/9999-99'}
                defaultValue={defaultValue}
            />

            {error && <span>{error}</span>}
        </>
    );
};

export default ReactInputCpfCnpj;
